// extracted by mini-css-extract-plugin
export var integrationButton = "_7c-0";